import {SEARCH_BY_TEXT, SEARCH_BY_CATEGORY, SEARCH_BY_AUTHOR_NAME,CLEAR_FILTER} from './actionTypes';

export const searchByText = (text) => {
    return {
        type: SEARCH_BY_TEXT,
        payload: text
    }
}
export const serachByCategory = (category) => {
    return {
        type: SEARCH_BY_CATEGORY,
        payload: category
    }
}

export const serachByAuthorName = (name) => {
    return {
        type: SEARCH_BY_AUTHOR_NAME,
        payload: name
    }
}
export const clearFilter = () => {
    return {
        type: CLEAR_FILTER
    }
}